import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        { time: 0, name: '欲漫涩', url: 'https://d15cdp17wrtows.cloudfront.net', webUrl: 'https://d1s8wm47asyysy.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d34oag60mr723b.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '麻豆', url: 'https://d11dszr8awyru3.cloudfront.net', webUrl: 'https://d2m1d86x8ze4id.cloudfront.net' },
        { time: 0, name: '海角乱伦', url: 'https://d2fmhutt07loza.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: 'pornhub中文版', url: 'https://d1ld8bakinxaqn.cloudfront.net', webUrl: 'https://d138tdacp9tlm.cloudfront.net' },
        { time: 0, name: 'xvideos', url: 'https://d39qpqkr0a2imh.cloudfront.net', webUrl: 'https://d4yzu2s8mrrvk.cloudfront.net' },

        { time: 0, name: '91porn', url: 'https://d1t0cnk3giny0c.cloudfront.net'},
        { time: 0, name: '萝莉岛', url: 'https://d1alfixdmc8fv0.cloudfront.net', webUrl: 'ttps://d2xw96fnbwxopk.cloudfront.net'},
        { time: 0, name: 'pornhub精品版', url: 'https://d2fd46yiy3nduv.cloudfront.net' },
        { time: 0, name: '妖精漫画', url: 'https://dl94i45mkvo19.cloudfront.net/' },
        { time: 0, name: 'YouTube', url: 'https://d25bo9n7ztxk1a.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d3uq99hs0j28bm.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d2vx9rpf9ijb2i.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: 'Soul', url: 'https://d3p20kuldfl13e.cloudfront.net', webUrl: 'https://d1u1x3yp88ozd.cloudfront.net' },
        { time: 0, name: '禁漫', url: 'https://d5bqarj6n2jmu.cloudfront.net' },
        { time: 0, name: '逼哩逼哩', url: 'https://d2z5pcp3hj41t5.cloudfront.net'},

        { time: 0, name: '波多', url: 'https://dla3s0q3qoa32.cloudfront.net' },
        { time: 0, name: 'XVideos破解版', url: 'https://d3pnpac3b9l22f.cloudfront.net' },
        { time: 0, name: '哆哔涩漫', url: 'https://d2v53pj1wsca2c.cloudfront.net'},
        { time: 0, name: '妻友', url: 'https://d3q2ufgkab6tdl.cloudfront.net' },

        { time: 0, name: '快手', url: 'https://d1rmio2ivfomt8.cloudfront.net' },
        { time: 0, name: 'XV暗网', url: 'https://d1dmpfqy7tcvam.cloudfront.net/' },
         { time: 0, name: '黑料社', url: 'https://d16ztykhxkw4bu.cloudfront.net/' },
        { time: 0, name: 'Tiktok成人版', url: 'https://d25xaxdudb28l6.cloudfront.net/' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 985
        window.open(url + '?dc=' + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
